FiltersMdl.directive( "family", ['$templateCache', 'UtilsSrv', function( $templateCache, UtilsSrv ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Filters/Families/Templates/_family.tpl.html'),
		link: function( scope, element ) {
			element.on('click', function(){
				UtilsSrv.scrollHandler.scrollToFans();
			})
		}
	}
}]);
